module.exports = __webpack_public_path__ + "static/img/IMG_20151229_222228.ea6e93f2.jpg";